export default  [
    
    {
        MC:"黄浦区",
        PID:"310101",
        ID:"310101000"
    },
    {
        MC:"南京东路街道",
        PID:"310101",
        ID:"310101002"
    },
    {
        MC:"外滩街道",
        PID:"310101",
        ID:"310101013"
    },
    {
        MC:"半淞园路街道",
        PID:"310101",
        ID:"310101015"
    },
    {
        MC:"小东门街道",
        PID:"310101",
        ID:"310101017"
    },
    {
        MC:"豫园街道",
        PID:"310101",
        ID:"310101018"
    },
    {
        MC:"老西门街道",
        PID:"310101",
        ID:"310101019"
    },
    {
        MC:"五里桥街道",
        PID:"310101",
        ID:"310101020"
    },
    {
        MC:"打浦桥街道",
        PID:"310101",
        ID:"310101021"
    },
    {
        MC:"淮海中路街道",
        PID:"310101",
        ID:"310101022"
    },
    {
        MC:"瑞金二路街道",
        PID:"310101",
        ID:"310101023"
    },
    {
        MC:"黄浦区（社保专用）",
        PID:"310101",
        ID:"310101999"
    },
    {
        MC:"徐汇区",
        PID:"310104",
        ID:"310104000"
    },
    {
        MC:"天平路街道",
        PID:"310104",
        ID:"310104003"
    },
    {
        MC:"湖南路街道",
        PID:"310104",
        ID:"310104004"
    },
    {
        MC:"斜土路街道",
        PID:"310104",
        ID:"310104007"
    },
    {
        MC:"枫林路街道",
        PID:"310104",
        ID:"310104008"
    },
    {
        MC:"长桥街道",
        PID:"310104",
        ID:"310104010"
    },
    {
        MC:"田林街道",
        PID:"310104",
        ID:"310104011"
    },
    {
        MC:"虹梅路街道",
        PID:"310104",
        ID:"310104012"
    },
    {
        MC:"康健新村街道",
        PID:"310104",
        ID:"310104013"
    },
    {
        MC:"徐家汇街道",
        PID:"310104",
        ID:"310104014"
    },
    {
        MC:"凌云路街道",
        PID:"310104",
        ID:"310104015"
    },
    {
        MC:"龙华街道",
        PID:"310104",
        ID:"310104016"
    },
    {
        MC:"漕河泾街道",
        PID:"310104",
        ID:"310104017"
    },
    {
        MC:"华泾镇",
        PID:"310104",
        ID:"310104103"
    },
    {
        MC:"漕河泾新兴技术开发区",
        PID:"310104",
        ID:"310104501"
    },
    {
        MC:"徐汇区（社保专用）",
        PID:"310104",
        ID:"310104999"
    },
    {
        MC:"长宁区",
        PID:"310105",
        ID:"310105000"
    },
    {
        MC:"华阳路街道",
        PID:"310105",
        ID:"310105001"
    },
    {
        MC:"江苏路街道",
        PID:"310105",
        ID:"310105002"
    },
    {
        MC:"新华路街道",
        PID:"310105",
        ID:"310105004"
    },
    {
        MC:"周家桥街道",
        PID:"310105",
        ID:"310105005"
    },
    {
        MC:"天山路街道",
        PID:"310105",
        ID:"310105006"
    },
    {
        MC:"仙霞新村街道",
        PID:"310105",
        ID:"310105008"
    },
    {
        MC:"虹桥街道",
        PID:"310105",
        ID:"310105009"
    },
    {
        MC:"程家桥街道",
        PID:"310105",
        ID:"310105010"
    },
    {
        MC:"北新泾街道",
        PID:"310105",
        ID:"310105011"
    },
    {
        MC:"新泾镇",
        PID:"310105",
        ID:"310105102"
    },
    {
        MC:"长宁区（社保专用）",
        PID:"310105",
        ID:"310105999"
    },
    {
        MC:"静安区",
        PID:"310106",
        ID:"310106000"
    },
    {
        MC:"江宁路街道",
        PID:"310106",
        ID:"310106006"
    },
    {
        MC:"石门二路街道",
        PID:"310106",
        ID:"310106011"
    },
    {
        MC:"南京西路街道",
        PID:"310106",
        ID:"310106012"
    },
    {
        MC:"静安寺街道",
        PID:"310106",
        ID:"310106013"
    },
    {
        MC:"曹家渡街道",
        PID:"310106",
        ID:"310106014"
    },
    {
        MC:"天目西路街道",
        PID:"310106",
        ID:"310108001"
    },
    {
        MC:"北站街道",
        PID:"310106",
        ID:"310108006"
    },
    {
        MC:"宝山路街道",
        PID:"310106",
        ID:"310108007"
    },
    {
        MC:"共和新路街道",
        PID:"310106",
        ID:"310108012"
    },
    {
        MC:"大宁路街道",
        PID:"310106",
        ID:"310108013"
    },
    {
        MC:"彭浦新村街道",
        PID:"310106",
        ID:"310108014"
    },
    {
        MC:"临汾路街道",
        PID:"310106",
        ID:"310108015"
    },
    {
        MC:"芷江西路街道",
        PID:"310106",
        ID:"310108016"
    },
    {
        MC:"彭浦镇",
        PID:"310106",
        ID:"310108101"
    },
    {
        MC:"静安区（社保专用）",
        PID:"310106",
        ID:"310106999"
    },
    {
        MC:"真如镇街道",
        PID:"310107",
        ID:"310107022"
    },
    {
        MC:"万里街道",
        PID:"310107",
        ID:"310107021"
    },
    {
        MC:"普陀区",
        PID:"310107",
        ID:"310107000"
    },
    {
        MC:"曹杨新村街道",
        PID:"310107",
        ID:"310107005"
    },
    {
        MC:"长风新村街道",
        PID:"310107",
        ID:"310107014"
    },
    {
        MC:"长寿路街道",
        PID:"310107",
        ID:"310107015"
    },
    {
        MC:"甘泉路街道",
        PID:"310107",
        ID:"310107016"
    },
    {
        MC:"石泉路街道",
        PID:"310107",
        ID:"310107017"
    },
    {
        MC:"宜川路街道",
        PID:"310107",
        ID:"310107020"
    },
    {
        MC:"长征镇",
        PID:"310107",
        ID:"310107102"
    },
    {
        MC:"桃浦镇",
        PID:"310107",
        ID:"310107103"
    },
    {
        MC:"普陀区（社保专用）",
        PID:"310107",
        ID:"310107999"
    },
    {
        MC:"虹口区",
        PID:"310109",
        ID:"310109000"
    },
    {
        MC:"欧阳路街道",
        PID:"310109",
        ID:"310109009"
    },
    {
        MC:"曲阳路街道",
        PID:"310109",
        ID:"310109010"
    },
    {
        MC:"广中路街道",
        PID:"310109",
        ID:"310109011"
    },
    {
        MC:"嘉兴路街道",
        PID:"310109",
        ID:"310109014"
    },
    {
        MC:"凉城新村街道",
        PID:"310109",
        ID:"310109016"
    },
    {
        MC:"四川北路街道",
        PID:"310109",
        ID:"310109017"
    },
    {
        MC:"北外滩街道",
        PID:"310109",
        ID:"310109018"
    },
    {
        MC:"江湾镇街道",
        PID:"310109",
        ID:"310109019"
    },
    {
        MC:"虹口区（社保专用）",
        PID:"310109",
        ID:"310109999"
    },
    {
        MC:"杨浦区",
        PID:"310110",
        ID:"310110000"
    },
    {
        MC:"定海路街道",
        PID:"310110",
        ID:"310110001"
    },
    {
        MC:"平凉路街道",
        PID:"310110",
        ID:"310110006"
    },
    {
        MC:"江浦路街道",
        PID:"310110",
        ID:"310110008"
    },
    {
        MC:"四平路街道",
        PID:"310110",
        ID:"310110009"
    },
    {
        MC:"控江路街道",
        PID:"310110",
        ID:"310110012"
    },
    {
        MC:"长白新村街道",
        PID:"310110",
        ID:"310110013"
    },
    {
        MC:"延吉新村街道",
        PID:"310110",
        ID:"310110015"
    },
    {
        MC:"殷行街道",
        PID:"310110",
        ID:"310110016"
    },
    {
        MC:"大桥街道",
        PID:"310110",
        ID:"310110018"
    },
    {
        MC:"五角场街道",
        PID:"310110",
        ID:"310110019"
    },
    {
        MC:"新江湾城街道",
        PID:"310110",
        ID:"310110020"
    },
    {
        MC:"五角场镇",
        PID:"310110",
        ID:"310110101"
    },
    {
        MC:"杨浦区（社保专用）",
        PID:"310110",
        ID:"310110999"
    },
    {
        MC:"长海路街道",
        PID:"310110",
        ID:"310110021"
    },
    {
        MC:"浦锦街道",
        PID:"310112",
        ID:"310112009"
    },
    {
        MC:"闵行区",
        PID:"310112",
        ID:"310112000"
    },
    {
        MC:"江川路街道",
        PID:"310112",
        ID:"310112001"
    },
    {
        MC:"古美街道",
        PID:"310112",
        ID:"310112006"
    },
    {
        MC:"新虹街道",
        PID:"310112",
        ID:"310112008"
    },
    {
        MC:"莘庄镇",
        PID:"310112",
        ID:"310112101"
    },
    {
        MC:"七宝镇",
        PID:"310112",
        ID:"310112102"
    },
    {
        MC:"颛桥镇",
        PID:"310112",
        ID:"310112103"
    },
    {
        MC:"华漕镇",
        PID:"310112",
        ID:"310112106"
    },
    {
        MC:"虹桥镇",
        PID:"310112",
        ID:"310112107"
    },
    {
        MC:"梅陇镇",
        PID:"310112",
        ID:"310112108"
    },
    {
        MC:"吴泾镇",
        PID:"310112",
        ID:"310112110"
    },
    {
        MC:"马桥镇",
        PID:"310112",
        ID:"310112112"
    },
    {
        MC:"浦江镇",
        PID:"310112",
        ID:"310112114"
    },
    {
        MC:"莘庄工业区",
        PID:"310112",
        ID:"310112501"
    },
    {
        MC:"闵行区（社保专用）",
        PID:"310112",
        ID:"310112999"
    },
    {
        MC:"宝山区",
        PID:"310113",
        ID:"310113000"
    },
    {
        MC:"友谊路街道",
        PID:"310113",
        ID:"310113003"
    },
    {
        MC:"吴淞街道",
        PID:"310113",
        ID:"310113007"
    },
    {
        MC:"张庙街道",
        PID:"310113",
        ID:"310113008"
    },
    {
        MC:"罗店镇",
        PID:"310113",
        ID:"310113101"
    },
    {
        MC:"大场镇",
        PID:"310113",
        ID:"310113102"
    },
    {
        MC:"杨行镇",
        PID:"310113",
        ID:"310113103"
    },
    {
        MC:"月浦镇",
        PID:"310113",
        ID:"310113104"
    },
    {
        MC:"罗泾镇",
        PID:"310113",
        ID:"310113106"
    },
    {
        MC:"顾村镇",
        PID:"310113",
        ID:"310113109"
    },
    {
        MC:"高境镇",
        PID:"310113",
        ID:"310113111"
    },
    {
        MC:"庙行镇",
        PID:"310113",
        ID:"310113112"
    },
    {
        MC:"淞南镇",
        PID:"310113",
        ID:"310113113"
    },
    {
        MC:"宝山城市工业园区",
        PID:"310113",
        ID:"310113501"
    },
    {
        MC:"宝山区（社保专用）",
        PID:"310113",
        ID:"310113999"
    },
    {
        MC:"嘉定区",
        PID:"310114",
        ID:"310114000"
    },
    {
        MC:"新成路街道",
        PID:"310114",
        ID:"310114001"
    },
    {
        MC:"真新街道",
        PID:"310114",
        ID:"310114002"
    },
    {
        MC:"菊园新区管委会",
        PID:"310114",
        ID:"310114003"
    },
    {
        MC:"嘉定镇街道",
        PID:"310114",
        ID:"310114004"
    },
    {
        MC:"南翔镇",
        PID:"310114",
        ID:"310114102"
    },
    {
        MC:"安亭镇",
        PID:"310114",
        ID:"310114103"
    },
    {
        MC:"马陆镇",
        PID:"310114",
        ID:"310114106"
    },
    {
        MC:"徐行镇",
        PID:"310114",
        ID:"310114109"
    },
    {
        MC:"华亭镇",
        PID:"310114",
        ID:"310114111"
    },
    {
        MC:"外冈镇",
        PID:"310114",
        ID:"310114114"
    },
    {
        MC:"江桥镇",
        PID:"310114",
        ID:"310114118"
    },
    {
        MC:"嘉定工业区",
        PID:"310114",
        ID:"310114501"
    },
    {
        MC:"嘉定区（社保专用）",
        PID:"310114",
        ID:"310114999"
    },
    {
        MC:"浦东新区",
        PID:"310115",
        ID:"310115000"
    },
    {
        MC:"潍坊新村街道",
        PID:"310115",
        ID:"310115004"
    },
    {
        MC:"陆家嘴街道",
        PID:"310115",
        ID:"310115005"
    },
    {
        MC:"周家渡街道",
        PID:"310115",
        ID:"310115007"
    },
    {
        MC:"塘桥街道",
        PID:"310115",
        ID:"310115008"
    },
    {
        MC:"上钢新村街道",
        PID:"310115",
        ID:"310115009"
    },
    {
        MC:"南码头路街道",
        PID:"310115",
        ID:"310115010"
    },
    {
        MC:"沪东新村街道",
        PID:"310115",
        ID:"310115011"
    },
    {
        MC:"金杨新村街道",
        PID:"310115",
        ID:"310115012"
    },
    {
        MC:"洋泾街道",
        PID:"310115",
        ID:"310115013"
    },
    {
        MC:"浦兴路街道",
        PID:"310115",
        ID:"310115014"
    },
    {
        MC:"东明路街道",
        PID:"310115",
        ID:"310115015"
    },
    {
        MC:"花木街道",
        PID:"310115",
        ID:"310115016"
    },
    {
        MC:"川沙新镇",
        PID:"310115",
        ID:"310115103"
    },
    {
        MC:"高桥镇",
        PID:"310115",
        ID:"310115104"
    },
    {
        MC:"北蔡镇",
        PID:"310115",
        ID:"310115105"
    },
    {
        MC:"合庆镇",
        PID:"310115",
        ID:"310115110"
    },
    {
        MC:"唐镇",
        PID:"310115",
        ID:"310115114"
    },
    {
        MC:"曹路镇",
        PID:"310115",
        ID:"310115117"
    },
    {
        MC:"金桥镇",
        PID:"310115",
        ID:"310115120"
    },
    {
        MC:"高行镇",
        PID:"310115",
        ID:"310115121"
    },
    {
        MC:"高东镇",
        PID:"310115",
        ID:"310115123"
    },
    {
        MC:"张江镇",
        PID:"310115",
        ID:"310115125"
    },
    {
        MC:"三林镇",
        PID:"310115",
        ID:"310115130"
    },
    {
        MC:"惠南镇",
        PID:"310115",
        ID:"310115131"
    },
    {
        MC:"周浦镇",
        PID:"310115",
        ID:"310115132"
    },
    {
        MC:"新场镇",
        PID:"310115",
        ID:"310115133"
    },
    {
        MC:"大团镇",
        PID:"310115",
        ID:"310115134"
    },
    {
        MC:"康桥镇",
        PID:"310115",
        ID:"310115136"
    },
    {
        MC:"航头镇",
        PID:"310115",
        ID:"310115137"
    },
    {
        MC:"祝桥镇",
        PID:"310115",
        ID:"310115139"
    },
    {
        MC:"泥城镇",
        PID:"310115",
        ID:"310115140"
    },
    {
        MC:"宣桥镇",
        PID:"310115",
        ID:"310115141"
    },
    {
        MC:"书院镇",
        PID:"310115",
        ID:"310115142"
    },
    {
        MC:"万祥镇",
        PID:"310115",
        ID:"310115143"
    },
    {
        MC:"老港镇",
        PID:"310115",
        ID:"310115144"
    },
    {
        MC:"南汇新城镇",
        PID:"310115",
        ID:"310115145"
    },
    {
        MC:"芦潮港农场",
        PID:"310115",
        ID:"310115401"
    },
    {
        MC:"东海农场",
        PID:"310115",
        ID:"310115402"
    },
    {
        MC:"朝阳农场",
        PID:"310115",
        ID:"310115403"
    },
    {
        MC:"中国（上海）自由贸易试验区（保税片区）",
        PID:"310115",
        ID:"310115501"
    },
    {
        MC:"金桥经济技术开发区",
        PID:"310115",
        ID:"310115502"
    },
    {
        MC:"张江高科技园区",
        PID:"310115",
        ID:"310115503"
    },
    {
        MC:"浦东新区（社保专用）",
        PID:"310115",
        ID:"310115999"
    },
    {
        MC:"金山区",
        PID:"310116",
        ID:"310116000"
    },
    {
        MC:"石化街道",
        PID:"310116",
        ID:"310116001"
    },
    {
        MC:"朱泾镇",
        PID:"310116",
        ID:"310116101"
    },
    {
        MC:"枫泾镇",
        PID:"310116",
        ID:"310116102"
    },
    {
        MC:"张堰镇",
        PID:"310116",
        ID:"310116103"
    },
    {
        MC:"亭林镇",
        PID:"310116",
        ID:"310116104"
    },
    {
        MC:"吕巷镇",
        PID:"310116",
        ID:"310116105"
    },
    {
        MC:"廊下镇",
        PID:"310116",
        ID:"310116107"
    },
    {
        MC:"金山卫镇",
        PID:"310116",
        ID:"310116109"
    },
    {
        MC:"漕泾镇",
        PID:"310116",
        ID:"310116112"
    },
    {
        MC:"山阳镇",
        PID:"310116",
        ID:"310116113"
    },
    {
        MC:"金山工业区",
        PID:"310116",
        ID:"310116503"
    },
    {
        MC:"金山区（社保专用）",
        PID:"310116",
        ID:"310116999"
    },
    {
        MC:"松江区",
        PID:"310117",
        ID:"310117000"
    },
    {
        MC:"岳阳街道",
        PID:"310117",
        ID:"310117001"
    },
    {
        MC:"永丰街道",
        PID:"310117",
        ID:"310117002"
    },
    {
        MC:"方松街道",
        PID:"310117",
        ID:"310117003"
    },
    {
        MC:"中山街道",
        PID:"310117",
        ID:"310117004"
    },
    {
        MC:"泗泾镇",
        PID:"310117",
        ID:"310117102"
    },
    {
        MC:"佘山镇",
        PID:"310117",
        ID:"310117103"
    },
    {
        MC:"车墩镇",
        PID:"310117",
        ID:"310117104"
    },
    {
        MC:"新桥镇",
        PID:"310117",
        ID:"310117105"
    },
    {
        MC:"洞泾镇",
        PID:"310117",
        ID:"310117106"
    },
    {
        MC:"九亭镇",
        PID:"310117",
        ID:"310117107"
    },
    {
        MC:"泖港镇",
        PID:"310117",
        ID:"310117109"
    },
    {
        MC:"石湖荡镇",
        PID:"310117",
        ID:"310117116"
    },
    {
        MC:"新浜镇",
        PID:"310117",
        ID:"310117117"
    },
    {
        MC:"叶榭镇",
        PID:"310117",
        ID:"310117120"
    },
    {
        MC:"小昆山镇",
        PID:"310117",
        ID:"310117121"
    },
    {
        MC:"松江工业区",
        PID:"310117",
        ID:"310117501"
    },
    {
        MC:"佘山度假区",
        PID:"310117",
        ID:"310117504"
    },
    {
        MC:"上海松江出口加工区",
        PID:"310117",
        ID:"310117507"
    },
    {
        MC:"广富林街道",
        PID:"310117",
        ID:"310117005"
    },
    {
        MC:"九里亭街道",
        PID:"310117",
        ID:"310117006"
    },
    {
        MC:"松江区（社保专用）",
        PID:"310117",
        ID:"310117999"
    },
    {
        MC:"青浦区",
        PID:"310118",
        ID:"310118000"
    },
    {
        MC:"夏阳街道",
        PID:"310118",
        ID:"310118001"
    },
    {
        MC:"盈浦街道",
        PID:"310118",
        ID:"310118002"
    },
    {
        MC:"香花桥街道",
        PID:"310118",
        ID:"310118003"
    },
    {
        MC:"朱家角镇",
        PID:"310118",
        ID:"310118102"
    },
    {
        MC:"练塘镇",
        PID:"310118",
        ID:"310118103"
    },
    {
        MC:"金泽镇",
        PID:"310118",
        ID:"310118104"
    },
    {
        MC:"赵巷镇",
        PID:"310118",
        ID:"310118105"
    },
    {
        MC:"徐泾镇",
        PID:"310118",
        ID:"310118106"
    },
    {
        MC:"华新镇",
        PID:"310118",
        ID:"310118107"
    },
    {
        MC:"重固镇",
        PID:"310118",
        ID:"310118109"
    },
    {
        MC:"白鹤镇",
        PID:"310118",
        ID:"310118110"
    },
    {
        MC:"青浦区（社保专用）",
        PID:"310118",
        ID:"310118999"
    },
    {
        MC:"奉贤区",
        PID:"310120",
        ID:"310120000"
    },
    {
        MC:"南桥镇",
        PID:"310120",
        ID:"310120101"
    },
    {
        MC:"奉城镇",
        PID:"310120",
        ID:"310120102"
    },
    {
        MC:"庄行镇",
        PID:"310120",
        ID:"310120104"
    },
    {
        MC:"金汇镇",
        PID:"310120",
        ID:"310120106"
    },
    {
        MC:"四团镇",
        PID:"310120",
        ID:"310120109"
    },
    {
        MC:"青村镇",
        PID:"310120",
        ID:"310120111"
    },
    {
        MC:"柘林镇",
        PID:"310120",
        ID:"310120118"
    },
    {
        MC:"海湾镇",
        PID:"310120",
        ID:"310120123"
    },
    {
        MC:"奉浦社区",
        PID:"310120",
        ID:"310120501"
    },
    {
        MC:"上海市奉贤区海湾旅游区",
        PID:"310120",
        ID:"310120503"
    },
    {
        MC:"金海社区",
        PID:"310120",
        ID:"310120504"
    },
    {
        MC:"上海海港综合经济开发区",
        PID:"310120",
        ID:"310120505"
    },
    {
        MC:"西渡街道",
        PID:"310120",
        ID:"310120001"
    },
    {
        MC:"奉贤区（社保专用）",
        PID:"310120",
        ID:"310120999"
    },
    {
        MC:"崇明区",
        PID:"310151",
        ID:"310230000"
    },
    {
        MC:"城桥镇",
        PID:"310151",
        ID:"310230101"
    },
    {
        MC:"堡镇",
        PID:"310151",
        ID:"310230102"
    },
    {
        MC:"新河镇",
        PID:"310151",
        ID:"310230103"
    },
    {
        MC:"庙镇",
        PID:"310151",
        ID:"310230104"
    },
    {
        MC:"竖新镇",
        PID:"310151",
        ID:"310230106"
    },
    {
        MC:"向化镇",
        PID:"310151",
        ID:"310230107"
    },
    {
        MC:"三星镇",
        PID:"310151",
        ID:"310230109"
    },
    {
        MC:"港沿镇",
        PID:"310151",
        ID:"310230113"
    },
    {
        MC:"中兴镇",
        PID:"310151",
        ID:"310230114"
    },
    {
        MC:"陈家镇",
        PID:"310151",
        ID:"310230115"
    },
    {
        MC:"绿华镇",
        PID:"310151",
        ID:"310230116"
    },
    {
        MC:"港西镇",
        PID:"310151",
        ID:"310230118"
    },
    {
        MC:"建设镇",
        PID:"310151",
        ID:"310230119"
    },
    {
        MC:"新海镇",
        PID:"310151",
        ID:"310230121"
    },
    {
        MC:"东平镇",
        PID:"310151",
        ID:"310230122"
    },
    {
        MC:"长兴镇",
        PID:"310151",
        ID:"310230123"
    },
    {
        MC:"新村乡",
        PID:"310151",
        ID:"310230201"
    },
    {
        MC:"横沙乡",
        PID:"310151",
        ID:"310230203"
    },
    {
        MC:"前卫农场",
        PID:"310151",
        ID:"310230409"
    },
    {
        MC:"东平林场",
        PID:"310151",
        ID:"310230410"
    },
    {
        MC:"上实现代农业园区",
        PID:"310151",
        ID:"310230501"
    },
    {
        MC:"崇明区（社保专用）",
        PID:"310151",
        ID:"310230999"
    }
]